import { defineComponent } from "@vue/composition-api";
import Vue from "vue";

import { mapState, mapMutations } from "vuex";
import { getBalanceOf } from "./wallet";
import { ethers } from "ethers";
Vue.mixin({
  data() {
    return {
    };
  },
  computed: {
    ...mapState([
      'ethAddress',
      'ethChainID',
      'overlay',
      'snackbar',
      'contract'
    ]),
  },
  methods: {
    ...mapMutations([
      'changeOverlay',
      'changeSnackbar',
      'changeContractAddress'
    ]),
    showI18nErrSnackbar(err) {
      this.$q.error(this.$te(err.message) ? this.$t(err.message) : err.message)
    }
  },
  mounted() {

  },
});

export const balanceMixin = defineComponent({
  data() {
    return {
      balance: '0',
      balanceLoading: false
    };
  },
  watch: {
    ethAddress() {
      this._reloadBalance()
    },
    ethChainID() {
      this._reloadBalance()
    }
  },
  methods: {
    async _reloadBalance() {
      this.balanceLoading = true
      try {
        this.balance = await getBalanceOf(this.ethAddress)
      } catch (err) { } finally {
        this.balanceLoading = false
      }
    }
  },
  mounted() {
    this._reloadBalance()
  }
})
